import React from 'react';
import PropTypes from 'prop-types';

import TableRow from '@material-ui/core/TableRow';

import OfferCell from './OfferCell';

const OfferRow = props => {
  const { row, columns, strings } = props;
  return columns.length > 0 ? (
    <TableRow>
      {columns.map(column => (
        <OfferCell
          strings={strings}
          data={row[column.id]}
          name={row[column.id]}
          type={column.type}
          key={`${row.id}-${column.id}`}
        />
      ))}
    </TableRow>
  ) : undefined;
};
OfferRow.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ),
  strings: PropTypes.object.isRequired, // eslint-disable-line
};

OfferRow.defaultProps = {
  row: [],
  columns: [],
};

export default OfferRow;
